import React, { useContext } from 'react';
import parse from 'html-react-parser';
import { Stack, Typography, CircularProgress, Box, Link } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { DTBPackageContext } from '../context';
import DTBPackageDtbs from './components/DTBPackageDtbs';
import CommonLayout from 'views/App/Portal/_layouts/CommonLayout';

const DetailDtbPackages: React.FC = () => {
  const { isLoading, isError, editedData } = useContext(DTBPackageContext);

  const breadcrumbItems = [
    <Link
      key='manage'
      href='/admin/dtbs/packages'
      underline='hover'
      color='inherit'
    >
      {t('dtbs.packages.breadcrumb.packageList', 'Package List')}
    </Link>,
    <Typography
      key='current'
      color='text.primary'
    >
      {t('dtbs.packages.breadcrumb.manage', 'Manage package')}
    </Typography>,
  ];

  return (
    <CommonLayout
      headerProps={{
        title: editedData ? `${parse(editedData.name || '')}` : t('dtbs.packages.detail.title'),
        breadcrumbItems,
      }}
    >
      <Box sx={{ display: 'grid', gridTemplateRows: 'auto 1fr', gap: 4, minHeight: 0 }}>
        {isLoading && (
          <Stack
            direction='row'
            justifyContent='center'
            sx={{ mb: 2 }}
          >
            <CircularProgress />
          </Stack>
        )}
        {isError && (
          <Typography
            color='error'
            sx={{ mb: 2 }}
          >
            {t('common.error')}
          </Typography>
        )}
        {!isLoading && !isError && editedData && <DTBPackageDtbs />}
      </Box>
    </CommonLayout>
  );
};

export default DetailDtbPackages;
